import React from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';

/**
 * CORE-311 — the rounded field of the mobile-web composer. With `pill` the
 * staged attachments (`header`) sit on top inside the field, and the attach
 * button, the input and the emoji button form its bottom row; without it the
 * children go straight into the composer row, exactly as before.
 */
export function ComposerField({ pill, style, rowStyle, header, children }: {
  pill: boolean;
  style: StyleProp<ViewStyle>;
  rowStyle: StyleProp<ViewStyle>;
  header?: React.ReactNode;
  children: React.ReactNode;
}) {
  if (!pill) return <>{children}</>;
  return (
    <View style={style} testID="chat-composer-field">
      {header}
      <View style={rowStyle}>{children}</View>
    </View>
  );
}
